<template>
<div>
  <el-button style="margin-top:2.5px;" size="mini" type="secondary" @click="openKedbPopup">KEDB</el-button> <!-- ToolTab의 tool 영역 안의 버튼이 IE에서 위치가 다른 버튼보다 올라가는 현상으로 margin-top 추가 -->
  <w-sliding-popup ref="kedbPopup" type="full" title="KEDB" :default-content="false" @close="closePopup">
    <div slot="content" class="body-content-no-scroll" style="height:100%;">
      <w-kedb-table v-show="isKedbViewFlag" ref="kedbTable" :filterTag="filterTag" :viewType="popupRef" :fit-height="true" @click-kedb-detail-view="clickKedbDetailView"></w-kedb-table>
      <!-- <el-scrollbar v-show="!isKedbViewFlag" class="bar-visible" :ref="scrollbarRef"> -->
        <w-kedb-detail-view v-show="!isKedbViewFlag" :params="kedbDetailParams" viewType="kedbDetailView" @click-change-kedb-view="changeKedbView"></w-kedb-detail-view>
      <!-- </el-scrollbar> -->
    </div>
  </w-sliding-popup>
</div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import WKedbTable from '../KedbTable';
import WKedbDetailView from '../KedbDetailView';

/**
 * KEDB 목록 팝업 및 버튼 컴포넌트
 * @author Ju
 */
export default {
  name: 'WKedbListPopupButton',
  components: {
    WKedbTable,
    WKedbDetailView,
  },
  data() {
    return {
      popupRef: 'kedbPopup',
      isKedbViewFlag: true,
      filterTag: {},
      kedbDetailParams: null,
    };
  },
  methods: {
    /**
     * KEDB 목록 팝업을 연다.
     * @author Ju
     */
    openKedbPopup() {
      this.popupRef = 'kedbPopup';
      this.$refs.kedbPopup.open();
    },
    /**
     * KEDB 목록 팝업을 닫는다.
     * @author yelim
     */
    closePopup() {
      this.popupRef = '';
      this.isKedbViewFlag = true;
      this.$refs.kedbTable.$refs.searchField.clear();
      this.$refs.kedbTable.searchType = 'total';
      this.$refs.kedbTable.selectRelationRsc = null;
      this.$refs.kedbTable.searchSortType = 'recentSort';
      // this.$refs.kedbPopup.visible = false;
    },
    /**
     * KEDB 상세 화면으로 전환한다.
     * @author yelim
     * @param  {[type]} params [description]
     */
    clickKedbDetailView(params) {
      this.filterTag = {};
      this.kedbDetailParams = params;
      this.isKedbViewFlag = false;
    },
    /**
     * KEDB 목록 화면으로 전환한다.
     * @author yelim
     * @param  {[type]} filterTag [description]
     */
    changeKedbView(filterTag) {
      this.kedbDetailParams = null;
      this.isKedbViewFlag = true;
      if (!isEmpty(filterTag)) {
        this.filterTag = filterTag;
      } else {
        this.$refs.kedbTable.loadData();
        this.$refs.kedbTable.loadRelationRscTag();
      }
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/event/kedb/components/button/KedbListPopupButton.vue